export default "__VITE_ASSET__oFrmNXQv__"